import { QueryClient } from "@tanstack/react-query";
import { cache } from "react";

/**
 * Create a new QueryClient instance
 * Used by both server and client but with different lifecycles
 */
export function makeQueryClient() {
	return new QueryClient({
		defaultOptions: {
			queries: {
				// Use DYNAMIC tier as default for server-side caching
				// This provides a good balance between performance and freshness
				// Individual hooks can override for STATIC (longer) or REALTIME (no cache)
				staleTime: 30 * 1000, // 30s (DYNAMIC tier default)
				gcTime: 10 * 60 * 1000, // 10min (DYNAMIC tier default)
				// Don't retry on server
				retry: false,
				// Server doesn't need refetch behaviors
				refetchOnWindowFocus: false,
				refetchOnReconnect: false,
				// Enhanced error handling for production
				throwOnError: false,
				// Better network mode handling for serverless
				networkMode: "online",
			},
			mutations: {
				// Optimistic updates enabled by default
				throwOnError: false,
				retry: 1,
			},
		},
	});
}

// Create a singleton query client for server components
// Using React cache to ensure the same instance per request
export const getQueryClient = cache(() => makeQueryClient());
